<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Чёрный список

  .container.mt-5
    .white_block
      .row
        .col
          h3 Блокировка
          | Номер телефона:
          input.phone(v-model="guest_phone", placeholder="+79999999999")
          button.btn.btn-primary.btn-sm(@click="ban", :disabled="loading") Заблокировать
          .quote Блокировка приведет к ограничению пушей, невозможности использования карты, удаления с карты данных владельца и запрет регистрации новой карты по указанному номеру телефона.
    .white_block
      .row
        .col
          h3 Список
          div(v-if="loading_list")
            | Загрузка...
          div(v-else)
            div(v-if="list.length == 0")
              | Нет заблокированных гостей 👍
            div(v-else)
              table.table.table-striped.table-bordered
                thead
                  tr
                    th#phone.text-center.font-weight-bold Телефон
                    th#date.text-center.font-weight-bold Дата
                    th#action.text-center.font-weight-bold Действия
                tbody
                  tr(v-for="(item, index) in list")
                    td#phone.text-center
                      | {{ item.phone }}
                    td#date.text-center
                      | {{ moment(item.createdAt).format('DD.MM.YYYY HH:mm') }}
                    td#action.text-center
                      button.btn.btn-danger.btn-sm(
                        @click="unban(item.phone)",
                        :disabled="loading",
                        :data-id="item.id"
                      ) Разблокировать
</template>

<script>
import { Tooltip } from "element-ui";
import apiDriver from "../../apiDriver";
import moment from "moment";

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      shopPath: "",
      guest_phone: "",
      list: [],
      loading: false,
      loading_list: true,
    };
  },

  computed: {},

  mounted() {
    this.loadBanned();
  },

  methods: {
    moment,
    async loadBanned() {
      this.loading_list = true;
      let loadBanned = await apiDriver.services.api.get(
        "cards",
        "settings/banned"
      );
      this.list = loadBanned.data.list;
      this.loading_list = false;
      console.log(this.list);
    },
    async ban() {
      if (
        this.guest_phone.length == 0 ||
        this.guest_phone.length != 12 ||
        this.guest_phone.substr(0, 1) != "+" ||
        this.guest_phone.substr(1, 1) != "7"
      ) {
        this.$toast.error("Необходим формат номера телефона: +79991231212");
        return;
      }
      this.loading = true;
      let result = await apiDriver.services.api.post(
        "cards",
        "settings/banClient",
        {
          phone: this.guest_phone,
        }
      );
      console.log("ban result", result.data);
      if (result.data.banned.done) {
        this.$toast.success("Гость заблокирован!");
        this.guest_phone = "";
      } else {
        this.$toast.error("Ошибка блокировки гостя");
      }
      this.loadBanned();
      this.loading = false;
    },
    async unban(phone) {
      this.loading = true;
      let result = await apiDriver.services.api.post(
        "cards",
        "settings/unbanClient",
        {
          phone: phone,
        }
      );
      console.log("unban result", result.data);
      if (result.data.unbanned.done) {
        this.$toast.success("Гость разблокирован!");
      } else {
        this.$toast.error("Ошибка разблокировки гостя");
      }
      this.loadBanned();
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="stylus">
h3 {
  margin-bottom: 0px;
}

.phone {
  margin-left: 10px;
  margin-right: 5px;
}

.quote {
  padding-left: 10px;
  border-left: 5px solid #e3e3e3;
  padding-bottom: 2px;
}

div {
  cursor: default;
}

a {
  margin-bottom: 2px;
  background: #3f51b5;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;

  &:hover {
    color: white;
  }

  &:focus {
    color: white;
  }
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.design {
  background: white;
}

.inputModule {
  margin-bottom: 10px;

  &.extended {
    border-left: 4px solid #f4f3ef;
    padding-left: 15px;
    margin-left: 10px;
    padding-top: 10px;
  }
}

@media (prefers-color-scheme: dark) {
  .quote {
    border-color: #404040;
  }

  table {
    color: white;
    background: #222222;
  }
}
</style>
